import { render } from "./product-range.vue?vue&type=template&id=24891d59"
import script from "./product-range.vue?vue&type=script&lang=js"
export * from "./product-range.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__